<template>
  <div v-if="step == 1" class="block step">
    <div
      class="block__item block__item--phieu_dieu_tour"
      @click="selectType('phieu_dieu_tour')"
    >
      <div class="block__item--icon">
        <i class="fas fa-ticket-alt"></i>
      </div>
      <p>PHIẾU ĐIỀU TOUR</p>
    </div>
    <div class="block__item block__item--hdld" @click="selectType('hdld')">
      <div class="block__item--icon">
        <i class="fas fa-file-contract"></i>
      </div>
      <p>HỢP ĐỒNG LAO ĐỘNG</p>
    </div>
  </div>
  <div class="card" v-else>
    <div class="card-body">
      <el-row :gutter="20" style="margin-bottom: 10px">
        <el-col :span="8" v-if="dataForm.typeFile == 'phieu_dieu_tour'">
          <div class="form__item">
            <p>Tour</p>
            <el-autocomplete
              class="inline-input"
              v-model="dataForm.ten_tour"
              :fetch-suggestions="querySearch"
              :placeholder="aLang.tt_enter_keywords_to_search"
              :trigger-on-focus="false"
              @select="handleSelect"
              @change="handleSelect"
              clearable
              style="width: 100%"
              :disabled="dataForm.isDisabled"
            >
              <template slot-scope="{ item }">
                <span class="link">{{ item.ten_tour }}</span>
              </template>
            </el-autocomplete>
          </div>
        </el-col>
        <el-col :span="8" v-if="dataForm.typeFile == 'hdld'">
          <div class="form__item">
            <p>Tìm hướng dẫn viên theo số thẻ</p>
            <el-autocomplete
              clearable
              class="inline-input"
              v-model="dataForm.itemHuongDanVien"
              :fetch-suggestions="querySearchHuongDanVienST"
              :placeholder="aLang.tt_enter_keywords_to_search"
              :trigger-on-focus="false"
              @select="handleSelectHuongDanVienST"
              style="min-width: calc(100% - 250px)"
              :disabled="dataForm.isDisabled"
            >
              <template slot-scope="{ item }">
                <span class="link">{{
                  item.ho_ten.ho_ten + " - số thẻ " + item.the_hdv.so_the
                }}</span>
              </template>
            </el-autocomplete>
          </div>
        </el-col>
        <el-col :span="8" v-if="dataForm.typeFile == 'hdld'">
          <div class="form__item">
            <p>Tìm hướng dẫn viên theo số giấy tờ</p>
            <el-autocomplete
              clearable
              class="inline-input"
              v-model="dataForm.itemHuongDanVien2"
              :fetch-suggestions="querySearchHuongDanVienSGT"
              :placeholder="aLang.tt_enter_keywords_to_search"
              :trigger-on-focus="false"
              @select="handleSelectHuongDanVienSGT"
              style="min-width: calc(100% - 250px)"
              :disabled="dataForm.isDisabled"
            >
              <template slot-scope="{ item }">
                <span class="link">{{
                  item.ho_ten.ho_ten +
                  " - số giấy tờ: " +
                  item.giay_to[0].so_giay_to
                }}</span>
              </template>
            </el-autocomplete>
          </div>
        </el-col>
        <el-col :span="8">
          <el-button
            @click="fn_add()"
            type="info"
            plain
            :disabled="dataForm.isDisabled"
          >
            {{
              dataForm.typeFile === "phieu_dieu_tour"
                ? "Tạo phiếu điều tour"
                : "Tạo hợp đồng"
            }}
          </el-button>
        </el-col>
      </el-row>
      <iframe
        v-if="dataForm.hdld_url"
        :src="dataForm.hdld_url"
        width="100%"
        height="680px"
        frameborder="0"
      ></iframe>
      <div v-else class="view">
        <p>
          Chọn
          {{
            dataForm.typeFile === "phieu_dieu_tour" ? "Tour" : "Hướng dẫn viên"
          }}
          để tạo
          {{
            dataForm.typeFile === "phieu_dieu_tour"
              ? "Phiếu điều tour"
              : "Hợp đồng lao động"
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import ValidService from "../../../service/ValidService";
import mushroom from "../../../service/api/dulich-api";
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      step: 1,
      dataForm: {
        tour_id: undefined,
        ten_tour: undefined,
        listTour: [],

        itemHuongDanVien: undefined,
        itemHuongDanVien2: undefined,
        so_the_huong_dan_vien: undefined,
        so_giay_to_huong_dan_vien: undefined,
        hdv_id: undefined,
        hdld_url: undefined,
        isDisabled: false,
        typeFile: undefined,
        // soThe: 292241297
        // sogiayto:038091035005
      },

      validForm: {
        tour_id: [ValidService.requiredChange],
        hdv_id: [ValidService.requiredChange],
      },
    };
  },
  methods: {
    selectType(type) {
      this.dataForm.typeFile = type;
      this.step = 2;
    },
    handleSelect(item) {
      this.dataForm.tour_id = item.id;
      this.dataForm.ten_tour = item.ten_tour;
    },
    handleSelectHuongDanVienST(item) {
      this.dataForm.itemHuongDanVien =
        (item.ho_ten && item.ho_ten.ho_ten) != null ? item.ho_ten.ho_ten : "";
      this.dataForm.so_the_huong_dan_vien =
        item.ho_ten.ho_ten + " - số thẻ " + item.the_hdv.so_the;
      this.dataForm.hdv_id = item.id;
    },
    handleSelectHuongDanVienSGT(item) {
      this.dataForm.itemHuongDanVien2 =
        (item.ho_ten && item.ho_ten.ho_ten) != null ? item.ho_ten.ho_ten : "";
      this.dataForm.hdv_id = item.id;

      this.dataForm.so_giay_to_huong_dan_vien =
        item.ho_ten.ho_ten + " - số giấy tờ: " + item.giay_to[0].so_giay_to;
    },

    async querySearch(queryString, cb) {
      const escapeRegex = (str) => str.replace(/[.*+?^${}()[\]\\]/g, "\\$&");

      const trimmedQuery = queryString.trim();
      const query1 = escapeRegex(trimmedQuery).replace(/%/g, "\\*");

      const resTourApi = await mushroom.tour.getAllAsync({
        filters: `ten_tour:regex_i:${query1}`,
      });

      const results = trimmedQuery
        ? resTourApi.result.filter((item) =>
            item.ten_tour.toLowerCase().includes(trimmedQuery.toLowerCase())
          )
        : resTourApi.result;

      cb(results);
    },
    async querySearchHuongDanVienST(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await mushroom.huong_dan_vien.listAsync({
        filters: `the_hdv.trang_thai=true&the_hdv.so_the=${encodeURIComponent(
          queryString
        )}`,
      });

      var results = queryString
        ? resHuongDanVienApi.result.filter((item) =>
            item.the_hdv.so_the.includes(queryString)
          )
        : resHuongDanVienApi.result;
      cb(results);
    },
    async querySearchHuongDanVienSGT(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await mushroom.huong_dan_vien.listAsync({
        filters: `the_hdv.trang_thai=true&giay_to.so_giay_to=${encodeURIComponent(
          queryString
        )}`,
      });

      var results = queryString
        ? resHuongDanVienApi.result.filter((item) =>
            item.giay_to[0].so_giay_to.includes(queryString)
          )
        : resHuongDanVienApi.result;
      cb(results);
    },
    async fn_add() {
      if (this.dataForm.typeFile === "hdld" && !this.dataForm.hdv_id) {
        window.toastr.warning("Vui lòng chọn Hướng dẫn viên");
        return;
      }
      if (
        this.dataForm.typeFile === "phieu_dieu_tour" &&
        !this.dataForm.tour_id
      ) {
        window.toastr.warning("Vui lòng chọn Tour");
        return;
      }
      if (this.dataForm.typeFile === "phieu_dieu_tour") {
        window.toastr.warning("Chức năng tạo Phiếu điều tour đang phát triển");
        return;
      }
      try {
        const response = await mushroom.hddt.sidoc_create_hdld_urlAsync({
          body: { hdv_id: this.dataForm.hdv_id },
        });
        if (response && response.result && response.result.url) {
          this.dataForm.hdld_url = response.result.url;
          this.dataForm.isDisabled = true;
        }
      } catch (error) {
        console.error("Có lỗi: %o", error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 800px;
  height: calc(100vh - 120px);
  margin: auto;
  &__item {
    cursor: pointer;
    height: 200px;
    width: 300px;
    font-size: 20px;
    border-radius: 20px;
    position: relative;
    display: grid;
    place-content: center;
    text-align: center;
    color: #fff;
    font-weight: bold;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    transition: 0.2s;
    p {
      margin-top: 50px;
    }
    &:hover {
      transform: scale(1.1);
    }
    &--phieu_dieu_tour {
      i {
        color: #4bb891;
      }
      background-color: #4bb891;
    }

    &--hdld {
      i {
        color: #8a73b9;
      }
      background-color: #8a73b9;
    }
  }
  &__item--icon {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    height: 100px;
    width: 200px;
    border-radius: 20px;
    display: grid;
    place-content: center;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    font-size: 50px;
  }
}
.form {
  &__item {
    display: flex;
    align-items: center;
    p {
      margin: 0 15px 0 0;
    }
  }
}
.view {
  height: 670px;
  display: grid;
  place-content: center;
}
.hdld {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
